class RatingStars {

	constructor(el) {
		this.$el          	= el;
		this.$starsFilled 	= el.find('.stars-filled');
		this.$countField 	= el.find('.count-field');

		this.rating     	= 0;
		this.count 			= 0;
		this.valuePercent	= 0;
		this.displayPercent	= 0;

		this.set;

		this.update();
		this.addEventListeners();
	}

	getRating() {
		this.rating = parseFloat(this.$el.data('rating'));
		this.count = parseInt(this.$el.data('rating-count'));
	}

	setRating(i) {
		this.$el.data({'rating': i});
		this.update();
	}

	calculate() {

		// value vs display percent - because you only want % to appear in the icon areas, not the gaps in between

		let poly0Rect = this.$el.find('.star-row polygon')[0].getBoundingClientRect();
		let poly1Rect = this.$el.find('.star-row polygon')[1].getBoundingClientRect();
		let polygonWidth = poly0Rect.width;
		let polygonDistance = poly1Rect.left - poly0Rect.left - polygonWidth;
		let totalWidth = (polygonWidth + polygonDistance) * 4 + polygonWidth;

		this.valuePercent = this.rating / 5;
		this.displayPercent = ((parseInt(this.valuePercent * 5) * (polygonWidth + polygonDistance) + ((this.valuePercent * 5 - parseInt(this.valuePercent * 5)) * polygonWidth)) / totalWidth);
	}

	setWidth() {
		this.$starsFilled.css({'width': `${this.displayPercent * 100}%`});
	}

	printCount() {
		if(this.$countField.length){
			let $valueField = this.$countField.find('.count-field-value');
			$valueField.html(this.count);
		}
	}

	update() {
		this.getRating();
		this.calculate();
		this.setWidth();
		this.printCount();
	}

	// listener methods

	_onUpdate() {
		this.update();
	}

	_onLiMouseEnter(e) {
		this.setRating($(e.currentTarget).index() + 1);
	}

	_onLiClick(e) {
		let i = $(e.currentTarget).index() + 1;
		this.setRating(i);
		this.set = i;
	}

	_onLiMouseLeave() {
		this.set ? this.setRating(this.set) : this.setRating(0);
	}

	// add listeners

	addEventListeners() {

		this.$el.on('update', this._onUpdate.bind(this));

		if (this.$el.data('editable')) {
			this.$el.find('li').on('mouseenter', this._onLiMouseEnter.bind(this));
			this.$el.find('ul').on('mouseleave', this._onLiMouseLeave.bind(this));
			this.$el.find('li').on('click', this._onLiClick.bind(this));
		}
	}

	removeEventListeners() {
		this.$el.on('update', this._onUpdate.bind(this));
		this.$el.find('li').off('mouseenter', this._onLiMouseEnter.bind(this));
		this.$el.find('ul').off('mouseleave', this._onLiMouseLeave.bind(this));
		this.$el.find('li').off('click', this._onLiClick.bind(this));
	}

}

module.exports = RatingStars;
